export default __webpack_public_path__ + "static/media/spark_62.8a3f4ac7.png";